const AUTO_OPEN_FROM_DAYS_LEFT = 7;

interface AutoOpenFlags {
  expired?: boolean;
  nearly_expired?: boolean;
}

export interface CurrentProductState {
  days_left?: number | null;
  subscription_status?: string;
}

export interface TrialAutoOpenProductState {
  currentProductState: CurrentProductState | undefined;
  getLocalStorageItem: () => unknown;
  setLocalStorageItem: (key: string, value: unknown) => void;
}

export default function trialModalAutoOpen(
  productState: TrialAutoOpenProductState,
): boolean {
  const { currentProductState } = productState;

  if (currentProductState?.subscription_status !== 'trial') {
    return false;
  }

  const daysLeft = currentProductState.days_left;

  if (
    daysLeft === undefined ||
    daysLeft === null ||
    daysLeft > AUTO_OPEN_FROM_DAYS_LEFT
  ) {
    return false;
  }

  const autoOpenFlags = productState.getLocalStorageItem() as
    | AutoOpenFlags
    | undefined;

  if (daysLeft > 0 && autoOpenFlags?.nearly_expired === undefined) {
    productState.setLocalStorageItem('nearly_expired', true);
    return true;
  }

  if (daysLeft === 0 && autoOpenFlags?.expired === undefined) {
    productState.setLocalStorageItem('expired', true);
    return true;
  }

  return false;
}
